import { httpRequest } from '@/clients/http'
import { local } from '@/db/repositories/local'
import * as catalog from '@/db/repositories/catalog'
import { configService } from '@/services/ConfigService'
import { PosModel } from '@/types'

export const CategoryModel = {
  getList: () =>
    configService.isDemo()
      ? httpRequest<PosModel.Category[]>({ method: 'get', url: '/pos/categories' })
      : local(catalog.getCategories()),
}
